import React, { Component } from 'react';
import UserTitle from '../components/user.title';
import UserSideMenu from '../components/user.side-menu';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../../../store/actions';
import { withRouter } from 'react-router-dom';
import Pagination from 'rc-pagination';
import _ from 'lodash';
import './purchase.css';
import DialogProductOverStock from '../../Dialog/dialog.product-over-stock';
import DialogProductReview from '../../Dialog/dialog.product-review';
import PurchaseItemPurchase from './components/purchase-item.purchase';
import FormCheckStatusOrder from './components/form-check-status-order.purchase';
import ItemsVoucherOrder from '../components/user.voucher-order';

class PurchaseMain extends Component {
  state = {
    orderData: this.props.orderData,
    currentPage: 1,
    rowsPerPage: 5,
    totalItems: this.props.orderData && this.props.orderData.length
  };

  componentDidMount() {
    this.props.orderData && this.handlerSet();
  }

  componentDidUpdate(prevProps, prevState) {
    !_.isEqual(prevProps.orderFilter, this.props.orderFilter) &&
      this.handlerSet();
  }

  handlerSet = () => {
    const { orderData, orderFilter } = this.props;
    const newOrderData = this.orderDataFilter(orderData, orderFilter);
    this.setState({ orderData: newOrderData, totalItems: newOrderData.length });
  };

  orderDataFilter = (data, filter) => {
    if (filter === 'ทั้งหมด') return data;
    return _.filter(data, (o) => o.status === filter);
  };

  handleCurrentPageChange = (currentPage) => {
    this.setState({ currentPage });
    window.scrollTo(0, 0);
  };

  handleChangeFilter = (name) => {
    const { UserOrderFilterChange } = this.props;
    this.setState({ currentPage: 1 });
    UserOrderFilterChange(name);
  };

  CreateOrder = () => {
    window.scrollTo(0, 0);
    const { orderData, currentPage, rowsPerPage } = this.state;
    const { wording, OpenDialogProductOverStock } = this.props;

    if (orderData && orderData.length > 0) {
      if (orderData?.every(item => item.orderType == "voucher")) {
        return (
          <ItemsVoucherOrder voucher={orderData} currentPage={currentPage} rowsPerPage={rowsPerPage} />
        );
      } else {
        return orderData
          .slice(
            (currentPage - 1) * rowsPerPage,
            (currentPage - 1) * rowsPerPage + rowsPerPage
          )
          .map((item) => {
            return (
              <PurchaseItemPurchase
                key={item.orderId}
                item={item}
                overStock={OpenDialogProductOverStock}
                review={(product) =>
                  this.handleOpenDialogProductReview(product, item)
                }
              />
            );
          });
      }
    }

    return (
      <div className="col-md-12 col-xs-12 product product-grid pt-10 pb-10 ml-10 mr-10">
        <div className=" text-center">
          <div className="icon-warpper">
            <img src="/assets/img/sf/not-found.png" alt="not-found.png" />
          </div>
          <h1 className="uppercase">{wording.purchase.YourOrder}</h1>
        </div>
      </div>
    );
  };

  handleOpenDialogProductReview = async (product, item) => {
    const { OpenDialogProductReview } = this.props;
    this.setState({ productSelected: { ...product, orderId: item.orderId } });
    OpenDialogProductReview();
  };

  render() {
    const { rowsPerPage, currentPage, totalItems } = this.state;
    const {
      orderData,
      orderFilter,
      wording,
      match,
      dialogStock,
      CloseDialogProductOverStock,
      CloseDialogProductReview,
      dialogReview,
      isAuthenticated
    } = this.props;

    let orderInvoice = match.params.hasOwnProperty("invoice");
    return (
      <div className="main-wrapper shop oh">

        <DialogProductOverStock
          open={dialogStock}
          closeDialog={CloseDialogProductOverStock}
        />
        <DialogProductReview
          open={dialogReview}
          closeDialog={CloseDialogProductReview}
          product={this.state.productSelected}
        />
        <UserTitle 
          title={wording.usermenu.purchase.myPurchase} 
          invoice={match.params.invoice}
        />

        {
          !(isAuthenticated || localStorage.getItem('Hello') !== null)
            ? (
              !(orderData && orderData.length > 0) 
                ? <FormCheckStatusOrder invoice={match.params.invoice} />
                : <div className="container mt-20 mb-20">{this.CreateOrder()}</div>
            )
            : orderInvoice 
              ?  <div className="container mt-20 mb-20">{this.CreateOrder()}</div>
              : (
                <section className="section-wrap pt-70 pb-40 catalogue">
                  <div className="container relative">
                    <div className="row">
                      <aside className="col-md-3 sidebar">
                        <UserSideMenu />
                      </aside>
                      <div className="col-md-9 catalogue-col right mb-50 container-list-user">
                        {orderData && orderData.length === 0 && (
                          <div className="shop-catalogue grid-view">
                            <div className="row text-center">
                              <div className="col-md-10 col-md-offset-1">
                                <div className="icon-warpper">
                                  <img
                                    src="/assets/img/sf/not-found.png"
                                    alt="not-found.png"
                                  />
                                </div>
                                <h1 className="uppercase">
                                  {wording.purchase.YourOrder}
                                </h1>
                              </div>
                            </div>
                          </div>
                        )}
                        {orderData && orderData.length > 0 && (
                          <div className="shop-catalogue grid-view">
                            <div className="mb-20">
                              <ul className="nav nav-pills nav-justified list-filter-user">
                                <li
                                  role="presentation"
                                  className={
                                    orderFilter === 'ทั้งหมด' ? 'active' : null
                                  }>
                                  <a
                                    className="pointer"
                                    onClick={() => this.handleChangeFilter('ทั้งหมด')}>
                                    {wording.usermenu.purchase.all}
                                  </a>
                                </li>
                                <li
                                  role="presentation"
                                  className={
                                    orderFilter === 'FAILED' ? 'active' : null
                                  }>
                                  <a
                                    className="pointer"
                                    onClick={() => this.handleChangeFilter('FAILED')}>
                                    {wording.usermenu.purchase.failed}
                                  </a>
                                </li>
                                <li
                                  role="presentation"
                                  className={
                                    orderFilter === 'PENDING' ? 'active' : null
                                  }>
                                  <a
                                    className="pointer"
                                    onClick={() => this.handleChangeFilter('PENDING')}>
                                    {wording.usermenu.purchase.pending}
                                  </a>
                                </li>
                                {/* <li
                                  role="presentation"
                                  className={
                                    orderFilter === 'SHIPPING' ? 'active' : null
                                  }>
                                  <a
                                    className="pointer"
                                    onClick={() => this.handleChangeFilter('SHIPPING')}>
                                    {wording.usermenu.purchase.shipping}
                                  </a>
                                </li> */}
                                <li
                                  role="presentation"
                                  className={
                                    orderFilter === 'DELIVERED' ? 'active' : null
                                  }>
                                  <a
                                    className="pointer"
                                    onClick={() =>
                                      this.handleChangeFilter('DELIVERED')
                                    }>
                                    {wording.usermenu.purchase.delivered}
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <div className="row items-grid">{this.CreateOrder()}</div>
                          </div>
                        )}
                        {totalItems > rowsPerPage && (
                          <div
                            className="mt-30"
                            style={{ display: 'flex', justifyContent: 'center' }}>
                            <Pagination
                              onChange={this.handleCurrentPageChange}
                              current={currentPage}
                              pageSize={rowsPerPage}
                              total={totalItems}
                              showTitle={false}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </section>
              )
        }
      </div>
    );
  }
}

const mapStateToProps = ({ user, language, product, login }) => ({
  orderFilter: user.purchase.filter,
  orderData: user.purchase.data,
  wording: language.wording,
  dialogStock: product.dialogStock,
  dialogReview: product.dialogReview,
  isAuthenticated: login.isAuthenticated
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      UserOrderFilterChange: Actions.UserOrderFilterChange,
      OpenDialogProductOverStock: Actions.OpenDialogProductOverStock,
      CloseDialogProductOverStock: Actions.CloseDialogProductOverStock,
      OpenDialogProductReview: Actions.OpenDialogProductReview,
      CloseDialogProductReview: Actions.CloseDialogProductReview
    },
    dispatch
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PurchaseMain)
);
